var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconDsb(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 0.75H1.75C1.19772 0.75 0.75 1.19772 0.75 1.75V5.75C0.75 6.30228 1.19772 6.75 1.75 6.75H5.75C6.30228 6.75 6.75 6.30228 6.75 5.75V1.75C6.75 1.19772 6.30228 0.75 5.75 0.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0.75H11.75C11.1977 0.75 10.75 1.19772 10.75 1.75V5.75C10.75 6.30228 11.1977 6.75 11.75 6.75H15.75C16.3023 6.75 16.75 6.30228 16.75 5.75V1.75C16.75 1.19772 16.3023 0.75 15.75 0.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 10.75H1.75C1.19772 10.75 0.75 11.1977 0.75 11.75V15.75C0.75 16.3023 1.19772 16.75 1.75 16.75H5.75C6.30228 16.75 6.75 16.3023 6.75 15.75V11.75C6.75 11.1977 6.30228 10.75 5.75 10.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 10.75H11.75C11.1977 10.75 10.75 11.1977 10.75 11.75V15.75C10.75 16.3023 11.1977 16.75 11.75 16.75H15.75C16.3023 16.75 16.75 16.3023 16.75 15.75V11.75C16.75 11.1977 16.3023 10.75 15.75 10.75Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDsb);
export default __webpack_public_path__ + "static/media/icon_dsb.a5c87c14d5174ec9720dd26a5bc990ec.svg";
export { ForwardRef as ReactComponent };